import React from 'react';
import { SearchForm } from 'components/header/navigation-bar/search-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

export const SearchNavItem = ({ showHide, onClick }) => {
  return (
    <div className="ct-search-nav-item" data-e2e="search-item">
      <SearchButton showHide={showHide} onClick={onClick} />
      {showHide && (
        <div className="ct-search-nav-item__search-form-hook">
          <SearchForm className="ct-search-nav-item__search-form-container" />
        </div>
      )}
    </div>
  );
};

const SearchButton = ({ showHide, onClick }) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      aria-pressed={showHide}
      data-e2e="search-videos-open-button"
      className={`ct-search-nav-item__tab${!showHide ? '' : ' ct-search-nav-item__tab--close'}`}
      aria-label={showHide ? t('search.close_button.label') : t('search.open_button.label')}
      onClick={onClick}
    >
      {!showHide ? (
        <FontAwesomeIcon icon={faSearch} />
      ) : (
        <div className="ct-search-nav-item__close-icon-extension">
          <FontAwesomeIcon icon={faTimes} />
        </div>
      )}
    </button>
  );
};
